// extracted by mini-css-extract-plugin
export var button = "Button-module--button--2t432";
export var buttonPrimary = "Button-module--button--primary--2woyF";
export var buttonSecondary = "Button-module--button--secondary--3V2Hf";
export var fadeOutAnimation = "Button-module--fadeOutAnimation--1HfNG";
export var fadeInAnimation = "Button-module--fadeInAnimation--2V04O";